<template>
    <div>
      <section class="py-5 bg-primary text-white arduino">
        <div class="container">
          <div class="">
            <swiper
              class="learn-slider"
              :slides-per-view="1"
              :space-between="50"
              :autoplay="{
                delay: 2500,
                disableOnInteraction: false,
              }"
              :pagination="{
                clickable: true,
              }"
              :navigation="true"
              :modules="modules"
            >
              <swiper-slide v-for="slide in 6" :key="slide">
               <div>
                <img src="../../assets/Images/house2.png" class="img-fluid" alt="">
               </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </section>
    </div>
  </template>
    
    <script>
  import { Swiper, SwiperSlide } from "swiper/vue";
  import "swiper/swiper.min.css";
  import "swiper/css/navigation";
  import { Autoplay, Pagination, Navigation } from "swiper";
  export default {
    name: "Arduino",
    components: {
      Swiper,
      SwiperSlide,
    },
    data() {
      return {};
    },
    setup() {
      return {
        modules: [Autoplay, Pagination, Navigation],
      };
    },
  };
  </script>
    
    <style scoped>
  .learn-slider {
    width: 70% !important;
    margin: 0 auto;
  }
  
  .learn-image {
    height: 400px;
  }
  
  .swiper-button-next,
  .swiper-button-prev {
    color: #ffffff;
    font-size: 30px;
    z-index: 900;
    color: white !important;
  }
  
  .swiper-button-next {
    right: 0px !important;
  }
  
  .swiper-button-prev {
    left: 0px !important;
  }
  
  
  .swiper {
    padding: 0 40px;
  }
  
  .showcase {
    height: 360px;
    background-image: url("../../assets/Images/knowus.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-blend-mode: darken;
    background-color: rgba(0, 0, 0, 0.1);
  }
  
  .showcase-content {
      width: 50%;
  }
  
  @media (max-width: 769px) {
    .learn-slider {
      width: 100% !important;
    }
  
    .showcase-content {
      width: 85%;
    }
  }
  </style>